import React, { useMemo } from 'react';
import { dataHooks } from '@wix/data-hooks';
import { classes } from './DeliveryOptionPreview.st.css';
import { Text, TextPriority } from 'wix-ui-tpa/cssVars';
import { useDeliverySectionData } from '../../provider/useDeliverySectionContext';
import { DeliveryInfoBox } from '../DeliveryOptionsPicker/DeliveryInfoBox/DeliveryInfoBox';
import { FreeShippingCouponType } from '../../consts';
import { useLocaleKeys } from '../../locale-keys/LocaleKeys';
import { SPECS } from '../../specs';
export const DeliveryOptionPreviewHooks = dataHooks('DeliveryOptionPreview');
export const DeliveryOptionPreview = () => {
  const localeKeys = useLocaleKeys();
  const {
    experiments
  } = useDeliverySectionData();
  const shouldSeperateAdditionalFeeFromPrice = experiments[SPECS.separateAdditionalFee];
  const {
    defaultSelectedDeliveryOptionData: selectedGroup,
    selectedDeliveryOption,
    appliedCouponType
  } = useDeliverySectionData();
  const selectedOption = useMemo(() => {
    return selectedGroup == null ? void 0 : selectedGroup.options.find(option => option.id === (selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id));
  }, [selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id, selectedGroup == null ? void 0 : selectedGroup.options]);
  const isFree = useMemo(() => (selectedGroup == null ? void 0 : selectedGroup.price) === 0, [selectedGroup == null ? void 0 : selectedGroup.price]);
  const priceText = useMemo(() => {
    if (isFree || appliedCouponType === FreeShippingCouponType) {
      return localeKeys.deliverySection.orderSummaryTotals.free.label();
    }
    return selectedGroup == null ? void 0 : selectedGroup.formattedPrice;
  }, [appliedCouponType, isFree, localeKeys.deliverySection.orderSummaryTotals.free, selectedGroup == null ? void 0 : selectedGroup.formattedPrice]);
  if (!selectedGroup) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": DeliveryOptionPreviewHooks.root(),
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": DeliveryOptionPreviewHooks.container(),
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.details
  }, /*#__PURE__*/React.createElement(Text, {
    priority: TextPriority.secondary
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": DeliveryOptionPreviewHooks.deliveryOptionTitle()
  }, selectedGroup == null ? void 0 : selectedGroup.title)), (selectedGroup == null ? void 0 : selectedGroup.pickupDetails) && /*#__PURE__*/React.createElement(Text, {
    priority: TextPriority.secondary,
    className: classes.subtitle
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": DeliveryOptionPreviewHooks.deliveryOptionPickupDetails()
  }, selectedGroup == null ? void 0 : selectedGroup.subtitle)), (selectedOption == null ? void 0 : selectedOption.deliveryTime) && /*#__PURE__*/React.createElement(Text, {
    priority: TextPriority.secondary,
    className: classes.subtitle
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": DeliveryOptionPreviewHooks.deliveryOptionDeliveryTime()
  }, selectedOption == null ? void 0 : selectedOption.deliveryTime)), shouldSeperateAdditionalFeeFromPrice && selectedGroup.additionalFeeSubtitle && /*#__PURE__*/React.createElement(Text, {
    priority: TextPriority.secondary,
    className: classes.subtitle
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": DeliveryOptionPreviewHooks.deliveryOptionAdditionalFeeSubtitle()
  }, selectedGroup == null ? void 0 : selectedGroup.additionalFeeSubtitle))), /*#__PURE__*/React.createElement(Text, {
    priority: TextPriority.secondary
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": DeliveryOptionPreviewHooks.deliveryOptionPrice()
  }, priceText))), /*#__PURE__*/React.createElement(DeliveryInfoBox, {
    instructions: selectedGroup == null ? void 0 : selectedGroup.instructions,
    insideTimeSelector: selectedGroup == null ? void 0 : selectedGroup.hasTimeSlots,
    isPickup: !!(selectedGroup != null && selectedGroup.pickupDetails)
  }));
};
//# sourceMappingURL=DeliveryOptionPreview.js.map